<template>
  <NSelect class="n-currency" v-bind="attrs" :get-popup-container="node => node.parentNode" />
</template>

<script setup>
import {useBootstrap} from '@front/hooks';
import {computed, watch} from 'vue';

const props = defineProps({
  value: undefined,
  bank: String,
});

const emit = defineEmits(['update:value']);

const { ENUMS, SELECTION } = useBootstrap();

const defaultOptions = computed(() => {
  const currencyKeys = SELECTION.Bank[props.bank]?.currencies;
  return ENUMS.value.Currency.filter(o => currencyKeys?.includes(o.name));
});

const attrs = computed(() => ({
  options: defaultOptions.value,
  label: 'currency',
  // ...useAttrs(),
  value: props.value,
  'onUpdate:value': v => emit('update:value', v),
}));

watch(
  () => defaultOptions.value,
  to => {
    if (props.value && !to.find(o => o.value === props.value)) {
      emit('update:value', null);
    }
  },
);
</script>

<script>
export default {
  name: 'NCurrency',
};
</script>
